import { render, staticRenderFns } from "./AdminUploadImagesComponent.vue?vue&type=template&id=e573bc34"
import script from "./AdminUploadImagesComponent.vue?vue&type=script&lang=js"
export * from "./AdminUploadImagesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports